/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  FlatTable,
  FlatTableBody,
  FlatTableHead,
  FlatTableHeader,
  FlatTableRow,
  FlatTableRowHeader
} from 'carbon-react/lib/components/flat-table';

import { formatCurrency } from '@futrli/localisation';

import { COADisplayAccount } from '../../types';
import { getAccountName, getFormattedYearToDate } from '../../utils';
import { usePredictManagementContext } from '../../../predict-management/context/predict-management-context';

import * as styles from './account-list-fr.scss';

interface Props {
  tableData: COADisplayAccount[];
  isBalanceSheet: boolean;
  syncStatusModified?: string;
  displayAccountCodes?: boolean;
}

export const AccountListFr = ({ tableData, isBalanceSheet, syncStatusModified, displayAccountCodes }: Props) => {
  const intl = useIntl();
  const { currency } = usePredictManagementContext();

  return (
    <div className={styles.container}>
      <FlatTable>
        <FlatTableHead>
          <FlatTableRow>
            <FlatTableHeader>
              <FormattedMessage id="reporting.grouping.accounts" defaultMessage="Accounts" />
            </FlatTableHeader>
            {isBalanceSheet ? null : (
              <FlatTableHeader width={120}>
                <FormattedMessage id="predict.days_to_pay" defaultMessage="Days to pay" />
              </FlatTableHeader>
            )}
            <FlatTableHeader width={120}>
              <FormattedMessage
                id="predict.ytd"
                defaultMessage="Yr to {dateFormat}"
                values={{ dateFormat: getFormattedYearToDate(intl, syncStatusModified) }}
              />
            </FlatTableHeader>
          </FlatTableRow>
        </FlatTableHead>

        <FlatTableBody>
          {tableData.map(account => (
            <FlatTableRow key={account.id}>
              <FlatTableRowHeader> {getAccountName(account, displayAccountCodes)}</FlatTableRowHeader>
              {isBalanceSheet ? null : <FlatTableRowHeader> {account.days_to_pay || '-'}</FlatTableRowHeader>}
              <FlatTableRowHeader>
                {' '}
                {!account.year_to_date
                  ? '-'
                  : formatCurrency(Number(account.year_to_date), intl, currency || undefined, 0, 0)}
              </FlatTableRowHeader>
            </FlatTableRow>
          ))}
        </FlatTableBody>
      </FlatTable>
    </div>
  );
};
